import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface StickyCTAProps {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
    show: boolean;
}

const StickyCTA: React.FC<StickyCTAProps> = ({ label, onClick, icon, show }) => {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ y: 100, x: '-50%', opacity: 0 }}
                    animate={{ y: 0, x: '-50%', opacity: 1 }}
                    exit={{ y: 100, x: '-50%', opacity: 0 }}
                    className="fixed bottom-8 left-1/2 z-50 md:hidden w-[90%] max-w-md"
                >
                    <button
                        onClick={onClick}
                        className="w-full bg-indigo-600 dark:bg-indigo-600 text-white font-black py-4 px-8 rounded-full shadow-2xl flex items-center justify-center gap-3 active:scale-95 transition-all border border-indigo-400/30 backdrop-blur-sm"
                    >
                        {icon}
                        <span className="uppercase tracking-wider text-sm">{label}</span>
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default StickyCTA;
